import { useTabsLogic } from "@profile/pages/MembershipPage/hooks/useTabsLogis";
import React from "react";
import { Tabs } from "../../Tabs/Tabs";
import { InvestorCard } from "../../InvestorCard/InvestorCard";
import { getInvestorCardsData } from "./const";
import { TiersComparisonTable } from "../../TiersComparisonTable/TiersComparisonTable";
import { AccountTier } from "@bundles/consts";

const tabsOptions = [
  {
    label: "Description",
    value: "description",
  },
  {
    label: "Features",
    value: "features",
  },
];

type WhatTypeOfInvestorProps = {
  isUk: boolean;
  userTier?: AccountTier;
  isHNW?: boolean;
};

export const WhatTypeOfInvestor = ({
  isUk,
  userTier,
  isHNW,
}: WhatTypeOfInvestorProps) => {
  const { activeTab, handleChangeActiveTab } = useTabsLogic(tabsOptions);

  const investorCardsData = getInvestorCardsData(userTier, isHNW);

  if (isUk) {
    return null;
  }

  return (
    <div style={{ marginTop: 80 }}>
      <h4 className="text-center mx-auto mb-7">
        What Type of Investor Account is Right For Me?
      </h4>

      <div
        className="mb-[40px] md:mb-[60px]"
        id="investor-accounts-secion-tabs"
      >
        <Tabs
          options={tabsOptions}
          activeValue={activeTab}
          onChange={handleChangeActiveTab}
        />
      </div>

      {activeTab === "description" && (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 md:py-[40px] px-[20px] py-[20px] mx-auto rounded-[20px] overflow-hidden border border-grey-lighter">
          {investorCardsData.map((card, index) => (
            <InvestorCard
              key={index}
              tier={card.tier}
              displaySeparator={index !== 0}
              tierImage={card.tierImage}
              additionalImage={card.additionalImage}
              title={card.title}
              description={card.description}
              buttonText={card.buttonText}
              buttonLink={card.buttonLink}
              disclaimer={card.disclaimer}
              userTier={userTier}
            />
          ))}
        </div>
      )}

      {activeTab === "features" && (
        <div>
          <TiersComparisonTable />
        </div>
      )}
    </div>
  );
};
